import Page, { getStaticProps as compGetStaticProps } from 'components/pages/Home';

export const getStaticProps = compGetStaticProps;
export default Page;
